import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import fetchCampaignData from "../Services/fetchCampaignData";
import useCurrentMasterCountry from "views/Components/Shared/hooks/useCurrentMasterCountry";
import { getCountryCode } from "../utils/country";

export default function useCampaignQuery() {
  const mainCountry = useCurrentMasterCountry();
  const mainCountryId = mainCountry?.id;
  const countryName = mainCountry?.name;
  const countryCode = getCountryCode(countryName);
  const { accessToken } = useAuth();

  const campaignQuery = useQuery({
    queryKey: ["campaignData", mainCountryId, countryCode],
    queryFn: () =>
      fetchCampaignData({
        accessToken,
        countryCode,
        mainCountryId,
      }),
    staleTime: Infinity,
    retry: false,
    placeholderData: (previousData) => previousData,
    enabled: !!mainCountryId && !!countryCode,
  });

  return campaignQuery;
}
